import { render } from "./BlockCena.vue?vue&type=template&id=0a76c7e2"
import script from "./BlockCena.vue?vue&type=script&lang=js"
export * from "./BlockCena.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__